import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { IoContactList } from './io-contact-list/io-contact-list';
import { IoContentFilter } from './io-content-filter/io-content-filter';

// IoContactList and IoContentFilter are kept NgModule-declared because
// short-call-home.ts (ActivityModule eager) statically imports both for template use.
// Making them standalone with imports:[SharedModule] risks TDZ circular-init at runtime.
// IoShortCallDetailsComponent, IoSelectionSheetComponent, SentimentChipComponent, and
// KeyMessageSentimentCardComponent are standalone and exit main.js via their consumers.
@NgModule({
  imports: [SharedModule],
  declarations: [IoContactList, IoContentFilter],
  exports: [IoContactList, IoContentFilter],
})
export class IoModule {}
